import React, {useState, useContext} from 'react';
import AppContext from './AppContext';
import { StyleSheet } from 'react-native';
import {Text, View} from '../components/Themed';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import {geocodeByAddress, getLatLng} from 'react-google-places-autocomplete';

const AddressAutocomplete = function (props: any) {
  const appContext = useContext(AppContext);

  const handleAddressChange = function (result: any, action: any) {
    appContext.startAddress = result['value']['description'];
    console.log('Set address to ', result['value']['description']);
    console.log(result);

    geocodeByAddress(result['value']['description'])
      .then((results) => getLatLng(results[0]))
      .then(function ({lat, lng}) {
        appContext.startLat = lat;
        appContext.startLon = lng;
        console.log('Successfully got latitude and longitude', {lat, lng});
      });
  };

  return (
      <GooglePlacesAutocomplete
        apiKey="AIzaSyAy3K6xbHzSmes_U6CeCQ56qDTv1v-Vxb8"
        selectProps={{
          placeholder: props.placeholder || 'Enter address',
          onChange: handleAddressChange,
          styles: {
            input: (provided: {}) => ({
              ...provided,
              color: 'black',
              fontFamily: 'Arial',
              width: '300px',
            }),
            option: (provided: {}) => ({
              ...provided,
              color: 'black',
              fontFamily: 'Arial',
            }),
            singleValue: (provided: {}) => ({
              ...provided,
              color: 'black',
              fontFamily: 'Arial',
            }),
          },
        }}
      />
  );
};

export default AddressAutocomplete;
